import React from 'react'
import { useTranslation } from 'react-i18next'
import CheckboxGroupPopover from '@/components/CheckboxGroupPopover'
import { useGetOptionsAndMap } from '../hook'

export const CUSTOM_ADDRESS = '__customAddress'
const RefundAddressType: React.FC = () => {
  const { t } = useTranslation()
  const { warehouseOptions } = useGetOptionsAndMap()

  const finalOptions = [{ label: t('refund.list.refundAddressType.custom'), value: CUSTOM_ADDRESS }, ...warehouseOptions]

  return <CheckboxGroupPopover name="refundAddressType" text={t('refund.list.refundAddressType')} dataSource={finalOptions} />
}

export default RefundAddressType
